import { render, staticRenderFns } from "./VCarouselItem.vue?vue&type=template&id=7cf5bf1b&scoped=true&"
import script from "./VCarouselItem.vue?vue&type=script&lang=js&"
export * from "./VCarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./VCarouselItem.vue?vue&type=style&index=0&id=7cf5bf1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf5bf1b",
  null
  
)

export default component.exports